<template>
  <div id="app">
    <main class="page-wrap bg">
      <Header />
      <RightMenu />
      <router-view />
    </main>
  </div>
</template>

<script>
import RightMenu from "./components/RightMenu";
import Header from "./components/Header";

export default {
  name: "app",
  components: {
    Header,
    RightMenu,
  },
};
</script>

<style lang="scss">
@import "../node_modules/rfs/scss";
@import url("https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;0,900;1,400&display=swap");

body,
html {
  height: 100%;
  font-family: "Lato", sans-serif;
}

main {
  height: 100vh;
  width: 100vw;
  text-align: center;
  overflow: auto;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-family: "Lato", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  width: 100%;
  color: black;
  background-color: white;
}
.page-title {
  margin: 1.5em 0;

  @media screen and (min-width: 768px) {
    margin-top: 0;
  }
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.bg {
  height: 100vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.NiceFontMenu {
  color: black;
  font-family: Caveat;
  text-align: center;
  @include font-size(1.3em);
}

button:focus {
  outline: none !important;
}

.button {
  font-family: "Hind Siliguri", sans-serif;
  font-size: 14px;
  letter-spacing: 0.1em;
  padding: 10px 20px;
  transition: all 0.2s ease-in-out;
  text-transform: uppercase;
  background-color: #fff;
}

.btn-filled-black {
  font-weight: 400;
  background-color: #ffa9be;
  border-radius: 2em;
  border: none;
  color: #000;

  &:hover {
    background-color: #ff8fab;
  }
}

.btn-filled-white {
  font-weight: 600;
  background-color: #ff6e92;
  border: 2px solid #ff6e92;
  border-radius: 4px;
  color: #fff;

  &:hover {
    background-color: #fff;
    color: #ff5d84;
  }
}

.btn-outlined {
  border: 2px solid #ff5d84;
  border-radius: 4px;
  color: #ff5d84;
  font-weight: 600;

  &:hover {
    background-color: #ff5d84;
    color: #fff;
  }
}
</style>
